module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "social-link",
    attrs: {
      "href": "https://auth2.multiplex.ua/galogin"
    }
  }, [_c('RoundGoogleIcon')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7624ba04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/open-id-buttons/GoogleBtn.vue
// module id = 426
// module chunks = 1